var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 12,
    viewBox: "0 0 45 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86357 9.66395L2.41557 4.22395V11.2H-0.00042963V-4.95911e-05H3.13557L6.04757 6.84795L9.08757 -4.95911e-05H11.9036V11.2H9.48757V4.22395L7.03957 9.66395H4.86357ZM14.7808 11.2V-4.95911e-05H22.2208V2.17595H17.2768V4.33595H21.4208V6.51195H17.2768V9.02395H22.2208V11.2H14.7808ZM30.2104 11.2L26.9624 3.77595V11.2H24.5464V-4.95911e-05H27.5224L30.7704 7.42395V-4.95911e-05H33.1864V11.2H30.2104ZM41.8701 -4.95911e-05H44.4301V7.35995C44.4301 9.93595 42.7501 11.36 40.1421 11.36C37.5501 11.36 35.8701 9.93595 35.8701 7.35995V-4.95911e-05H38.4301V7.24795C38.4301 8.41595 38.9901 9.18395 40.1421 9.18395C41.3101 9.18395 41.8701 8.41595 41.8701 7.24795V-4.95911e-05Z",
    fill: "#E79A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/MENU.2a254d21a548c144dff48a3c54cb0d1c.svg";
export { ForwardRef as ReactComponent };